import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';

export namespace NCmsBlogImageCopy {
    export const componentId = 'blog-more-to-explore';

    export interface IComponentData extends NICmsContentComponent.IData {
        text: string;
        labels: ILabel[];
    }

    export interface ILabel {
        text: string;
        link: string;
    }
}

@ICmsComponent<CmsBlogComponentMoreToExploreComponent>({
    id: NCmsBlogImageCopy.componentId,
    name: 'Blog more to explore',
    tags: ['Blog', 'Tags'],
    isAdvanced: true,
    onDemandOnly: true,
    fields: [
        {
            key: 'text',
            title: 'Text',
            type: NICmsContentField.EFieldType.text,
            required: true,
            default: 'More to explore:'
        },
        <NICmsContentField.IRepeaterField>{
            key: 'labels',
            type: NICmsContentField.EFieldType.repeater,
            title: 'Labels',
            itemName: 'label',
            itemNameField: 'label',
            fields: [
                {
                    key: 'text',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Text',
                    required: true,
                    default: 'Label'
                },
                {
                    key: 'link',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Link',
                    required: true,
                    default: '/'
                }
            ]
        }
    ],
    priority: 20
})
@Component({
    selector: 'cms-blog-component-more-to-explore',
    templateUrl: './cms-blog-component-more-to-explore.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CmsBlogComponentMoreToExploreComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component?: NCmsBlogImageCopy.IComponentData;
}
